import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ThumbsUp from 'components/svgs/thumbs-up';

const propTypes = {
  display: PropTypes.bool,
  bookExtendedTimes: PropTypes.bool,
};

const defaultProps = {
  display: false,
  bookExtendedTimes: false,
};

const AutoExtendTooltipToggleButton = ({
  display,
  bookExtendedTimes,
}) => {
  if (!display) { return null; }

  let text;
  if (bookExtendedTimes) {
    text = (<FormattedMessage
      id="checkout.keep-original-time"
      defaultMessage="No. Keep my original time"
    />);
  } else {
    text = (<FormattedMessage
      id="checkout.take-extended-time"
      defaultMessage="Yes, I'll take it"
    />);
  }

  return (
    <div className="auto-extend-toggle padding-left-15">
      <ThumbsUp />
      <div className="auto-extend-toggle-label">
        {text}
      </div>
    </div>
  );
};

AutoExtendTooltipToggleButton.propTypes = propTypes;
AutoExtendTooltipToggleButton.defaultProps = defaultProps;
export default AutoExtendTooltipToggleButton;
